export default function anonymous(context
) {
var out='<u>'+( context.stringFromRow(context.object.initialRow) )+'</u><br />'+( context.object.print('text') );return out;
}